export default __webpack_public_path__ + "assets/images/toggle-drawer-icon.b200a37389bc3691eb4cbb0e800e83a7.png";